/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar, IntScalar } from "graphql-jsx";
import { ValidType } from "constants/ValidType";
import { ValidTypeScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  id: string;
  typeArtist: string | null;
  value: string;
  languageCode: string;
  order: number;
  validCheck?: ValidType;
}>;

export const CreateArtistTitleRelation = async (option: Option) => {
  const $id = <Variable name="artist_Id" scalar={<IdScalar />} value={option.id} />;
  const $typeArtist = <Variable name="type_title" scalar={<StringScalar isNullable={false} />} value={option.typeArtist} />;
  const $value = <Variable name="value" scalar={<StringScalar isNullable={false} />} value={option.value} />;
  const $languageCode = <Variable name="language_code" scalar={<IdScalar />} value={option.languageCode} />;
  const $order = <Variable name="exposure_order" scalar={<IntScalar />} value={option.order} />;
  const $validCheck = <Variable name="valid_check" scalar={<ValidTypeScalar isNullable />} value={option.validCheck} />;
  const { query, variables } = render(
    <Mutation operationName="CREATE_ARTIST_TITLE_RELATION">
      <SelectionSet
        name="updateArtist"
        alias="createArtistTitleRelation"
        argument={{
          where: {
            artist_id: $id
          },
          data: {
            _onlySearch: true,
            artist_title: {
              create: [
                {
                  type_artist_title: $typeArtist,
                  exposure_order: $order,
                  language: { connect: { language_code: $languageCode } },
                  value: $value,
                  valid_check: $validCheck
                }
              ]
            }
          }
        }}
      >
        <Field name="artist_id" alias="id" />
        <SelectionSet name="artist_title" alias="titleRelation">
          <Field name="id" alias="uuid" />
        </SelectionSet>
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    createArtistTitleRelation: {
      id: string;
      titleRelation: {
        uuid: string;
      }[];
    };
  }>;

  return await clients.artist.request<Data>(query, variables);
};
